// extracted by mini-css-extract-plugin
export var dropdown = "_id-0";
export var imagePlaceholder = "_id-2";
export var imageWrapper = "_id-3";
export var productImage = "_id-1";
export var truncateContainer = "_id-4";
export var truncateText = "_id-5";